import Api from './rest/TaskReminderApi';

export default new Api();
